import {
  Button,
  Card,
  Checkbox,
  Divider,
  Empty,
  Modal,
  Radio,
  Select,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import Loader from "../../../components/loader";
import AccountService from "../../../services/accounts.service";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { MdOutlineEdit } from "react-icons/md";
import { setDepositAccountList } from "../../../store/actions/app.action";
import ModifyAccountNickName from "./setNickname";
import { amountFormat } from "../../../services/common.service";
import checkedIcon from "../../../assests/images/checked.svg";
import unCheckedIcon from "../../../assests/icons/uncheck.png";
import { useTranslation } from "react-i18next";
import DepositListItem from "./deposits/depositListView";
import DepositGridView from "./deposits/depositGrid";

export default function DepositList() {
  const [dataSource, setDataSource] = useState([]);
  const [noRecords, setNoRecords] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const [selectedDetails, setSelectedDetails] = useState({});
  const [showGridAccount, setShowGridAccount] = useState("GRID");
  const { t } = useTranslation();

  useEffect(() => {
    fetchAccounts("FD");
  }, []);

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  const fetchAccounts = useCallback(async (type) => {
    try {
      setDataSource([]);
      const response = await AccountService.getDepositAccountSummary(type);
      if (response.status === 200) {
        setDataSource(response.data);
        setNoRecords(response.data.length > 0 ? false : true);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, []);

  const handleChange = useCallback(
    (value, option) => {
      setDataSource((prevDataSource) =>
        prevDataSource.map((account) =>
          account.accountNo === option.accountNo
            ? { ...account, checked: value }
            : { ...account, checked: false }
        )
      );
    },
    []
  );


  return (
    <>
    {showGridAccount === "GRID" && (
        <DepositGridView
          dataSource={dataSource}
          setVisible={setVisible}
          noRecords={noRecords}
          handleChange={handleChange}
          setSelectedDetails={setSelectedDetails}
        />
      )}

      {showGridAccount === "LIST" && (
        <DepositListItem
          dataSource={dataSource}
          setVisible={setVisible}
          noRecords={noRecords}
          handleChange={handleChange}
        />
      )}

      <Modal
        title={t("pages.my_accounts.casa.nickname", {
          defaultValue: "Nickname",
        })}
        closable={false}
        maskClosable={false}
        open={visible}
        footer={null}
        width={480}
        mask={true}
      >
        <ModifyAccountNickName
          key={new Date().getTime()}
          setVisible={setVisible}
          selectedDetails={selectedDetails}
          setRefresh={() => {
            dispatch(setDepositAccountList([]));
            setVisible(false);
            fetchAccounts("FD");
          }}
        />
      </Modal>
    </>
  );
}
